/**
 * A record the source panel can describe. `kind` says which panel shape to render; a citation
 * reaches us as a markdown link, so it is read from the label the report writes.
 */
export type SourceKind = 'statistic' | 'forecast' | 'survey' | 'web';

/** One label/value line in the property table. Rows with no value are dropped before render. */
export interface SourceRow {
  label: string;
  value: string;
}

interface SourceBase {
  title: string;
  subject?: string;
  /** Absent when the record carries no citable URL, which is normal for two Statista kinds. */
  url?: string;
}

export interface WebSource extends SourceBase {
  kind: 'web';
  /** Publication name, shown as the panel's first header line. */
  site: string;
  domain: string;
}

export interface StatistaSource extends SourceBase {
  kind: Exclude<SourceKind, 'web'>;
  rows: SourceRow[];
  /** Raw HTML from Statista; anchors survive, every other tag is stripped at render. */
  descriptionHtml?: string;
}

export type Source = WebSource | StatistaSource;

export const isWebSource = (source: Source): source is WebSource => source.kind === 'web';
